import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = ({ lang }) => {
  const data = {
    EN: {
      about: "AP News provides comprehensive coverage of global events, politics, technology, and culture. We are committed to truth, accuracy, and providing a voice to the voiceless across the globe.",
      catTitle: "News Categories",
      infoTitle: "Corporate",
      contactTitle: "Get in Touch",
      // Categories object with display name and route path
      links: [
        { name: "World News", path: "/category/International" },
        { name: "Climate Change", path: "/category/Tech" },
        { name: "Business & Finance", path: "/category/Business" },
        { name: "Tech Innovations", path: "/category/Tech" },
        { name: "Lifestyle Trends", path: "/category/Showbiz" },
        { name: "Sports Arena", path: "/category/Sports" },
        { name: "Health & Wellness", path: "/category/Health" }
      ],
      corp: ["About AP News", "Editorial Policy", "Code of Ethics", "Work with Us", "Investor Relations", "Advertising"],
      copy: "© 2026 AP News. All Rights Reserved."
    },
    UR: {
      about: "اے پی نیوز  ملکی ,عالمی واقعات، سیاست، ٹیکنالوجی اور ثقافت کی جامع کوریج فراہم کرتا ہے۔ ہم سچائی، درستگی اور دنیا بھر میں آواز سے محروم لوگوں کی آواز بننے کے لیے پرعزم ہیں۔",
      catTitle: "نیوز کیٹگریز",
      infoTitle: "کارپوریٹ",
      contactTitle: "رابطہ کریں",
      // Urdu Categories mapped to dynamic category routes
      links: [
        { name: "عالمی خبریں", path: "/category/International" },
        { name: "ماحولیاتی تبدیلی", path: "/category/Tech" },
        { name: "کاروبار و مالیات", path: "/category/Business" },
        { name: "ٹیکنالوجی", path: "/category/Tech" },
        { name: "لائف اسٹائل", path: "/category/Showbiz" },
        { name: "اسپورٹس", path: "/category/Sports" },
        { name: "صحت و تندرستی", path: "/category/Health" }
      ],
      corp: ["اے پی نیوز کے بارے میں", "ادارتی پالیسی", "اخلاقی ضابطہ", "ہمارے ساتھ کام کریں", "انویسٹر ریلیشنز", "اشتہارات"],
      copy: "© 2026 اے پی نیوز۔ جملہ حقوق محفوظ ہیں۔"
    }
  }[lang];

  return (
    <footer  className={styles.footer} dir={lang === 'UR' ? 'rtl' : 'ltr'}>
      <div className={styles.footerGrid}>
        {/* Brand Section */}
        <div className={`${styles.column} ${styles.brandSection}`}>
          <img src="./logo.png" alt="AP News" />
          <p>{data.about}</p>
        </div>

        {/* Categories (Now Clickable) */}
        <div className={styles.column}>
          <h4>{data.catTitle}</h4>
          <ul color='black'>
            {data.links.map((link, idx) => (
              <li key={idx}>
                <Link to={link.path} className={styles.footerLink}>
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Corporate */}
        <div className={styles.column}>
          <h4>{data.infoTitle}</h4>
          <ul>
            {data.corp.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className={styles.column}>
          <h4>{data.contactTitle}</h4>
          <p> <b>Pakistan Address,</b><br/>Faisal Avenue, Abpara<br/>Islamabad, Pakistan.<br/><b> USA Address,</b><br/>91 Ferry Street , Suite 3 , Jersey City NJ 07307.<br/>America.<br/>  Email: contact@apnews.pk</p>

        </div>
      </div>

      <div className={styles.developerNote}>
        <p>{data.copy} | Designed & Engineered by <strong style={{color: "golden"}}>DevDana</strong></p>
      </div>
    </footer>
  );
};

export default Footer;